import {
  getSeoPattern as publicGetSeoPattern,
  listSeoPatterns as publicListSeoPatterns,
  listSeoPatternVariables as publicListSeoPatternVariables,
  createSeoPattern as publicCreateSeoPattern,
  setSeoPattern as publicSetSeoPattern,
  resetSeoPatternToDefault as publicResetSeoPatternToDefault,
} from './promote-seo-v1-seo-pattern-seo-patterns.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getSeoPattern: MaybeContext<
  BuildRESTFunction<typeof publicGetSeoPattern> & typeof publicGetSeoPattern
> = /*#__PURE__*/ createRESTModule(publicGetSeoPattern);
export const listSeoPatterns: MaybeContext<
  BuildRESTFunction<typeof publicListSeoPatterns> & typeof publicListSeoPatterns
> = /*#__PURE__*/ createRESTModule(publicListSeoPatterns);
export const listSeoPatternVariables: MaybeContext<
  BuildRESTFunction<typeof publicListSeoPatternVariables> &
    typeof publicListSeoPatternVariables
> = /*#__PURE__*/ createRESTModule(publicListSeoPatternVariables);
export const createSeoPattern: MaybeContext<
  BuildRESTFunction<typeof publicCreateSeoPattern> &
    typeof publicCreateSeoPattern
> = /*#__PURE__*/ createRESTModule(publicCreateSeoPattern);
export const setSeoPattern: MaybeContext<
  BuildRESTFunction<typeof publicSetSeoPattern> & typeof publicSetSeoPattern
> = /*#__PURE__*/ createRESTModule(publicSetSeoPattern);
export const resetSeoPatternToDefault: MaybeContext<
  BuildRESTFunction<typeof publicResetSeoPatternToDefault> &
    typeof publicResetSeoPatternToDefault
> = /*#__PURE__*/ createRESTModule(publicResetSeoPatternToDefault);

export {
  PatternSource,
  Origin,
  WebhookIdentityType,
} from './promote-seo-v1-seo-pattern-seo-patterns.universal.js';
export {
  SeoPattern,
  SeoPatternBlob,
  Tag,
  GetSeoPatternRequest,
  GetSeoPatternResponse,
  ListSeoPatternsRequest,
  ListSeoPatternsResponse,
  ListSeoPatternVariablesRequest,
  ListSeoPatternVariablesResponse,
  SeoPatternVariable,
  CreateSeoPatternRequest,
  CreateSeoPatternResponse,
  SetSeoPatternRequest,
  SetSeoPatternResponse,
  ResetSeoPatternToDefaultRequest,
  ResetSeoPatternToDefaultResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  GetSeoPatternOptions,
  SetSeoPatternOptions,
  ResetSeoPatternToDefaultOptions,
} from './promote-seo-v1-seo-pattern-seo-patterns.universal.js';
export {
  PatternSourceWithLiterals,
  OriginWithLiterals,
  WebhookIdentityTypeWithLiterals,
  GetSeoPatternApplicationErrors,
  ListSeoPatternVariablesApplicationErrors,
  CreateSeoPatternApplicationErrors,
  SetSeoPatternApplicationErrors,
  ResetSeoPatternToDefaultApplicationErrors,
} from './promote-seo-v1-seo-pattern-seo-patterns.universal.js';
